import React from 'react';

import { usePool } from '~features/pools';
import { UserPoolStats } from '~features/pools/components/BuyFromWrapper/UserPoolStats';

export function SaleFinishedMessage({ soldOut }: { soldOut: boolean }) {
  return (
    <div className="space-y-3">
      <p className="text-lg text-center">
        {soldOut ? '🎉 The sale is sold out! 🎉' : 'The sale is finished'}
      </p>

      <UserPoolStats />
    </div>
  );
}
